<template>
  <HomeWidgetSmall
    :actionButtonHandler="navigateToUpcomingExpirations"
    actionButtonText="manage upcoming password expirations"
    :hasError="hasError"
    :isLoading="isLoading"
    :metric="numUsersWithUpcomingExpirations"
    :metricDescription="metricDescription"
    small
    :widgetType="upcomingPasswordExpiration"
  />
</template>

<script>
import { ItemTypeConsts, ItemTypeRoutes } from 'client/util/Constants';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapActions } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';
import HomeWidgetSmall from 'client/HomePageV2/widgets/HomeWidgetSmall';
import SystemUserApi from 'client/api/v2/SystemUserApi';
import SystemUserFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/SystemUserFilters';
import Util from 'client/util/Util';
import pluralize from 'pluralize';

const {
  widgetTypes,
} = HomeWidgetConsts;

const {
  upcomingPasswordExpiration,
} = widgetTypes;

const {
  description,
  location,
  section,
  toUrl,
  text: textEventProp,
} = eventProperties;
const {
  homePage,
} = eventLocations;

export default {
  name: 'UpcomingPasswordExpirationWidget',

  components: {
    HomeWidgetSmall,
  },

  viewAllRoute: ItemTypeRoutes[ItemTypeConsts.viewUpcomingPasswordExpiration],

  data: () => ({
    hasError: false,
    isLoading: true,
    numUsersWithUpcomingExpirations: 0,
    upcomingPasswordExpiration,
  }),

  computed: {
    metricDescription() {
      const passwordPlural = pluralize('password', this.numUsersWithUpcomingExpirations);
      const expirePlural = this.numUsersWithUpcomingExpirations === 1 ? 'expires' : 'expire';
      return `${passwordPlural} ${expirePlural} in 2 weeks or less`;
    },

    upcomingExpirationFilter() {
      return SystemUserFilters.passwordExpiring(14);
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    ...mapActions('SystemUserCollection', [
      'setFilters',
    ]),

    fetchData() {
      return SystemUserApi.fetch(null, 1, null, null, null, this.upcomingExpirationFilter)
        .then(({ totalCount }) => {
          this.numUsersWithUpcomingExpirations = totalCount;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    navigateToUpcomingExpirations() {
      EventHelper.triggerWidgetClicked({
        [description]: 'Upcoming Password Expiration Widget - Home Page',
        [location]: homePage,
        [section]: 'Home Widgets',
        [toUrl]: this.$options.viewAllRoute,
        [textEventProp]: 'Upcoming Password Expiration Widget',
      });
      Util.redirect(this.$options.viewAllRoute);
    },
  },
};
</script>
